import moment from "moment";

export default class PublicBuyCourseDateApplicant {
  constructor(raw = {}) {
    this.firstName = '';
    this.lastName = '';
    this.birthdateString = '';
    this.birthdate = "";
    this.email = '';
    this.invoiceAddress = '';
    this.wantsToBorrowBooks = false;
    this.borrowBooksAddress = '';
    this.lastAssessmentDateString = '';
    this.lastAssessmentDate = "";
  }

  isValid(needLastAssessment) {
    return this.firstName.length > 0 &&
        this.lastName.length > 0 &&
        this.email.length > 0 &&
        moment(this.birthdateString, 'DD.MM.YYYY', true).isValid() &&
        (needLastAssessment === false || moment(this.lastAssessmentDateString, 'DD.MM.YYYY', true).isValid()) &&
        (this.wantsToBorrowBooks === false || this.borrowBooksAddress.length > 0);
  }

  prepare() {
    this.birthdate = moment(this.birthdateString, "DD.MM.YYYY",
        true).toISOString();
    this.lastAssessmentDate = moment(this.lastAssessmentDateString,
        "DD.MM.YYYY", true).toISOString();
  }
}
